<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>棋盘主题配置</span>
        </div>
        <el-row :gutter="10" class="mb8" style="margin-top: 5px;">
          <CommonExport :import-p="'config:chessBoardSkin:import'" :export-p="'config:chessBoardSkin:export'" :get-table="getTables" :import-method="importChessSkinCfg" :export-method="exportChessSkinCfg" />
          <el-col :span="1.5">
            <el-button
              v-permisaction="['config:chessBoardSkin:export']"
              type="primary"
              icon="el-icon-download"
              size="mini"
              @click="exportJsonData"
            >导出JSON</el-button>
          </el-col>

        </el-row>

        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="活动皮肤">
            <el-select v-model.number="act.isOpen" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <span v-if="act.isOpen === 1">
            <el-form-item label="名称">
              <el-input v-model.trim="act.title" style="width: 200px;" placeholder="名称" />
            </el-form-item>
            <el-form-item label="主题">
              <el-input v-model="act.skin" style="width: 200px;" placeholder="主题" />
            </el-form-item>
            <el-form-item label="最小等级">
              <el-input v-model.number="act.minLevel" style="width: 150px;" placeholder="最小等级" />
            </el-form-item>
            <el-form-item label="格子颜色">
              <el-input v-model.number="act.color" style="width: 150px;" placeholder="格子颜色" />
            </el-form-item>
          </span>
          <el-button v-permisaction="['config:chessBoardSkin:add']" type="primary" @click="onSaveAct()">保存</el-button>
        </el-form>

        <el-table
          :data="formData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="levelId"
            label="等级"
          >
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.levelId" placeholder="等级" />
            </template>
          </el-table-column>

          <el-table-column
            prop="title"
            label="名称"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.title" placeholder="名称" />
            </template>
          </el-table-column>

          <el-table-column
            prop="skin"
            label="主题"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.skin" placeholder="主题" />
            </template>
          </el-table-column>

          <el-table-column
            prop="color"
            label="格子颜色"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.color" placeholder="格子颜色" />
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
          >
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:chessBoardSkin:del']" type="danger" @click="del(scope.row.levelId)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-button v-permisaction="['config:chessBoardSkin:add']" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:chessBoardSkin:add']" type="primary" @click="onSubmit()">保存</el-button>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import {
  delChessSkinCfg, exportChessSkinCfg,
  getChessSkinList,
  importChessSkinCfg,
  updateChessSkinCfg
} from '@/api/config/chess-board-skin-cfg'
import CommonExport from '@/components/CommonExport/index.vue'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
export default {
  name: 'ChessBoardSkinConfig',
  components: {
    CommonExport
  },
  data() {
    return {
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 50
      },
      options: [{
        value: 1,
        label: '开启'
      }, {
        value: 0,
        label: '关闭'
      }],
      act: {
        isOpen: 0,
        skin: '',
        title: '',
        minLevel: 1
      },
      formData: [
        {
          'levelId': 1,
          'name': '',
          'skin': '',
          'color': ''
        }
      ]
    }
  },
  created() {
    this.getTables()
    this.getActTables()
  },
  methods: {
    exportChessSkinCfg,
    importChessSkinCfg,
    onSubmit() {
      for (const i in this.formData) {
        const val = this.formData[i]
        if (val.title === '') {
          this.msgError('名称不能为空')
          return
        }
        if (val.skin === '') {
          this.msgError('皮肤不能为空')
          return
        }
      }

      const data = JSON.stringify(this.formData)
      console.log(data)
      updateChessSkinCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getChessSkinList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      const len = this.formData.length
      this.formData.push({
        'levelId': len + 1,
        'name': '',
        'skin': '',
        'color': ''
      })
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delChessSkinCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    exportJsonData() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/exportChessBoardSkinCfg')
    },
    getActTables() {
      getCommonCfg({ name: 'actChessBoardSkin' }).then(res => {
        if (res.code === 200) {
          this.act = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSaveAct() {
      if (this.act.isOpen) {
        if (this.act.title === '') {
          this.msgError('活动-名称不能为空')
          return
        }

        if (this.act.skin === '') {
          this.msgError('活动-名称皮肤不能为空')
          return
        }
        if (this.act.minLevel <= 0) {
          this.msgError('活动-最小等级不能小于0')
          return
        }
      }

      const data = JSON.stringify(this.act)
      updateCommonCfg({ name: 'actChessBoardSkin', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
